const handleLoadPreviusForm = (setState) => (obj) => {
  setState((prevState) => ({
    ...prevState,
    values: { ...obj },
  }));
};

export default handleLoadPreviusForm;
